import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import styles from './RoundButton.module.scss'
import { Button } from '@material-ui/core'

const RoundButton = ({ text, className, disabled, ...props }) => {
  const classNames = cn(styles.roundButton, className)

  return (
    <Button className={classNames} disabled={disabled} {...props}>
      {text}
    </Button>
  )
}

RoundButton.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
}

export default RoundButton
